import { createConsola } from 'consola';

export const consola = createConsola({
	level: import.meta.env.DEV ? 4 : 0,
	defaults: { tag: 'app' },
});
